import { Component, HostBinding, OnInit, inject } from '@angular/core';
import { PreviewTokenService } from '@app/shared/services/preview-token.service';

@Component({
	selector: 'g-preview-banner',
	templateUrl: './preview-banner.component.html',
	styleUrls: ['./preview-banner.component.scss'],
	standalone: false,
})
export class PreviewBannerComponent implements OnInit {
	private readonly previewTokenService = inject(PreviewTokenService);

	@HostBinding('class.preview-mode') showPreviewBanner = false;

	ngOnInit(): void {
		this.previewTokenService.token$.subscribe((previewToken) => {
			if (previewToken) {
				this.showPreviewBanner = true;
			}
		});
	}
}
